// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Backdrop overlay */
.rgm-chat-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Main container for the chat component */
.rgm-chat-container {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  /* transition: all 0.3s ease; */
}

/* Collapsed state - normal positioning */
.rgm-chat-container.rgm-chat-collapsed {
  margin: 0 10px 10px 10px;
  position: relative;
  z-index: 1;
}

/* Expanded state - full viewport modal */
.rgm-chat-container.rgm-chat-expanded {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 97vw;
  /* max-width: 1200px; */
  height: 97vh;
  margin: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

/* Header section with title and chevron */
.rgm-chat-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  flex-shrink: 0;
}

.rgm-chat-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  /* margin-right: 8px; */
}

/* Mode Dropdown */
.rgm-chat-mode-dropdown-container {
  position: relative;
  /* margin-left: 4px; */
}

.rgm-chat-mode-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  transition: background-color 0.2s;
  width: fit-content;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rgm-chat-mode-dropdown-trigger:hover {
  background-color: #f0f0f0;
}

.rgm-chat-mode-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 120px;
  max-width: 300px;
  padding: 4px 0;
  overflow: hidden;
}

.rgm-chat-mode-dropdown-item {
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rgm-chat-mode-dropdown-item:hover {
  background-color: #f5f5f5;
}

.rgm-chat-mode-dropdown-item.active {
  background-color: #e6f7ff;
  color: #0078d4;
  font-weight: 500;
}

.rgm-chat-model-select-container {
  position: relative;
  margin-right: 20px;
}

.rgm-chat-model-select-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.rgm-chat-model-select-trigger:hover {
  background-color: #f0f0f0;
}

.rgm-chat-model-select-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 120px;
  padding: 4px 0;
}

.rgm-chat-model-select-item {
  padding: 8px 12px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.rgm-chat-model-select-item:hover {
  background-color: #f5f5f5;
}

.rgm-chat-model-select-item.active {
  background-color: #e6f7ff;
  color: #0078d4;
  font-weight: 500;
}

.rgm-chat-chevron {
  display: flex;
  align-items: center;
  margin-left: auto;
}

/* Chat body - contains messages and form */
.rgm-chat-body {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* Thread sidebar */
.rgm-thread-bar {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 170px;
  flex-shrink: 0;
  border-right: 1px solid #e0e0e0;
  background: #f5f6f8;
}

.rgm-thread-bar-resize-handle {
  position: absolute;
  top: 0;
  right: -6px;
  width: 12px;
  height: 100%;
  cursor: col-resize;
  z-index: 2;
}

.rgm-thread-bar-resize-handle:hover {
  background: rgba(0, 0, 0, 0.08);
}

.rgm-thread-bar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #dde0e4;
  flex-shrink: 0;
}

.rgm-thread-bar-title {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.rgm-thread-new-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #555;
  padding: 0 2px;
  border-radius: 4px;
}

.rgm-thread-new-btn:hover {
  background: #e0e3e8;
  color: #222;
}

.rgm-thread-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 0;
  min-width: 0;
}

.rgm-thread-item {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 4px;
  border-radius: 6px;
  margin: 2px 4px;
  box-sizing: border-box;
  transition: background 0.1s;
}

.rgm-thread-item:hover {
  background: #e4e7ec;
}

.rgm-thread-item-active {
  background: #dce6f5;
}

.rgm-thread-item-active:hover {
  background: #cddaf0;
}

.rgm-thread-item-btn {
  flex: 1 1 auto;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
  color: #333;
  padding: 6px 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  box-sizing: border-box;
}

/* ⋯ menu button */
.rgm-thread-menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  color: #aaa;
  padding: 2px 5px;
  border-radius: 4px;
  flex-shrink: 0;
  display: none;
}
.rgm-thread-item:hover .rgm-thread-menu-btn,
.rgm-thread-item-active .rgm-thread-menu-btn {
  display: block;
}
.rgm-thread-menu-btn:hover {
  color: #333;
  background: #d0d4da;
}

/* Inline rename input */
.rgm-thread-rename-input {
  flex: 1;
  font-size: 12px;
  border: 1px solid #4f46e5;
  border-radius: 4px;
  padding: 3px 6px;
  outline: none;
  min-width: 0;
  background: #fff;
}

/* Context menu */
.rgm-thread-context-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #dde0e4;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  padding: 4px 0;
}
.rgm-thread-context-item {
  display: block;
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 7px 14px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
}
.rgm-thread-context-item:hover {
  background: #f0f2f5;
}
.rgm-thread-context-item--danger {
  color: #c0392b;
}
.rgm-thread-context-item--danger:hover {
  background: #fde8e6;
}

/* Delete confirmation overlay */
.rgm-thread-delete-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}
.rgm-thread-delete-modal {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  min-width: 220px;
  text-align: center;
}
.rgm-thread-delete-modal p {
  margin: 0 0 16px;
  font-size: 14px;
  color: #333;
}
.rgm-thread-delete-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.rgm-thread-delete-cancel,
.rgm-thread-delete-confirm {
  padding: 6px 16px;
  border-radius: 5px;
  border: none;
  font-size: 13px;
  cursor: pointer;
}
.rgm-thread-delete-cancel {
  background: #e8eaed;
  color: #333;
}
.rgm-thread-delete-cancel:hover {
  background: #d8dade;
}
.rgm-thread-delete-confirm {
  background: #c0392b;
  color: #fff;
}
.rgm-thread-delete-confirm:hover {
  background: #a93226;
}

.rgm-thread-empty {
  font-size: 11px;
  color: #aaa;
  text-align: center;
  padding: 16px 8px;
}

/* Main chat area (messages + form) */
.rgm-chat-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

/* Wrapper for the message list */
.rgm-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  background-color: #ffffff;
  min-height: 0;
}

/* Individual message container */
.rgm-chat-message {
  display: flex;
  margin-bottom: 10px;
}

/* Wrapper for bubble and feedback - ensures vertical stacking */
.rgm-chat-message-content {
  display: flex;
  flex-direction: column;
  width: min(75vw, 100%);
  max-width: 75vw;
  align-items: flex-start;
}

.rgm-chat-bubble {
  padding: 10px 14px;
  border-radius: 18px;
  line-height: 1.4;
  display: inline-block;
  width: auto;
  max-width: 75vw;
  box-sizing: border-box;
  align-self: flex-start;
}

.rgm-chat-bubble.rgm-chat-disclaimer {
  font-size: 12px;
  color: #6b7280;
  background-color: #f8fafc;
  border: 1px solid #e5e7eb;
}

/* Override for tables/charts - needs full width */
.rgm-chat-bubble:has(.rgm-chat-table-container),
.rgm-chat-bubble:has(.ag-theme-alpine) {
  display: block;
  width: 75vw;
  max-width: 75vw;
}

/* RGM (analyst) messages */
.rgm-chat-message.RGM {
  justify-content: flex-start;
}
.rgm-chat-message.RGM .rgm-chat-bubble {
  background-color: #f1f0f0;
  color: #333;
}

/* User messages */
.rgm-chat-message.user {
  justify-content: flex-end;
}
.rgm-chat-message.user .rgm-chat-message-content {
  align-items: flex-end;
}
.rgm-chat-message.user .rgm-chat-bubble {
  background-color: #0078a0;
  color: white;
  align-self: flex-end;
}

.rgm-chat-input-disclaimer {
  font-size: 12px;
  color: #6b7280;
  text-align: left;
  padding: 4px 2px 4px;
  background-color: #f9f9f9;
}

.rgm-chat-input-row {
  display: flex;
  align-items: flex-end;
}

.rgm-chat-form {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  flex-shrink: 0;
}

/* Collapsed form styling */
.rgm-chat-form-collapsed {
  border-top: none;
}

.rgm-chat-input {
  flex-grow: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 15px;
  font-size: 14px;
  line-height: 1.4;
  margin-right: 10px;
  resize: none;
  overflow-y: hidden;
  box-sizing: border-box;
  height: 36px;
  font-family: inherit;
}
.rgm-chat-input:focus {
  outline: none;
  border-color: #0078a0;
  box-shadow: 0 0 0 2px rgba(0, 120, 160, 0.2);
}

.rgm-chat-send-btn {
  border: none;
  background-color: #0078a0;
  color: white;
  font-weight: 600;
  border-radius: 20px;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}
.rgm-chat-send-btn:hover {
  background-color: #005f7e;
}
.rgm-chat-stop-btn {
  background-color: #b03a2e;
}
.rgm-chat-stop-btn:hover {
  background-color: #8c2d24;
}

/* Feedback section - appears below the bubble */
.rgm-chat-feedback {
  margin-top: 8px;
  display: block;
  width: 100%;
}

.rgm-chat-feedback-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rgm-chat-feedback-btn {
  background: transparent;
  border: none;
  border-radius: 999px;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  min-height: 26px;
  font-size: 14px;
  line-height: 1;
}

.rgm-chat-feedback-btn:hover:not(:disabled) {
  background: rgba(79, 70, 229, 0.1);
}

.rgm-chat-feedback-btn.active {
  background: rgba(79, 70, 229, 0.2);
}

.rgm-chat-feedback-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.rgm-chat-feedback-thanks {
  font-size: 12px;
  color: #4f46e5;
  font-style: italic;
}

.rgm-chat-feedback-text-container {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.rgm-chat-feedback-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  box-sizing: border-box;
}

.rgm-chat-feedback-textarea:focus {
  outline: none;
  border-color: #4f46e5;
}

.rgm-chat-feedback-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.rgm-chat-feedback-submit {
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.rgm-chat-feedback-submit:hover {
  background: #3730a3;
}

.rgm-chat-feedback-cancel {
  background: transparent;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.rgm-chat-feedback-cancel:hover {
  background: #f5f5f5;
  border-color: #999;
}

/* Table and Chart Container */
.rgm-chat-table-container {
  width: 100%;
  margin: 10px 0;
}

.rgm-chat-table-grid {
  width: 100%;
  overflow: auto;
}

.rgm-chat-table-controls {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 8px;
}

.rgm-chat-view-toggle-btn {
  background: #0078a0;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.rgm-chat-view-toggle-btn:hover {
  background: #005f7e;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 120, 160, 0.3);
}

.rgm-chat-view-toggle-btn:active {
  transform: translateY(0);
}

.rgm-chat-copy-chart-btn {
  background: #e8f4f8;
  color: #0078a0;
  border: 1px solid #0078a0;
  border-radius: 6px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.rgm-chat-copy-chart-btn:hover {
  background: #d0eaf3;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 120, 160, 0.2);
}

.rgm-chat-copy-chart-btn:active {
  transform: translateY(0);
}

.rgm-chat-copy-chart-btn.copied {
  background: #e6f4ea;
  color: #1a7f37;
  border-color: #1a7f37;
}

.rgm-chat-copy-chart-btn.error {
  background: #fce8e6;
  color: #c5221f;
  border-color: #c5221f;
}

/* Metric Selector */
.rgm-chart-metric-selector {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
}

.rgm-chart-metric-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.rgm-chart-metric-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.rgm-chart-metric-checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #495057;
  transition: color 0.2s;
}

.rgm-chart-metric-checkbox-label:hover {
  color: #0078a0;
}

.rgm-chart-metric-checkbox {
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #0078a0;
}

.rgm-chart-metric-name {
  user-select: none;
}

/* Chart wrapper */
.rgm-chat-chart-wrapper {
  width: 100%;
  max-width: 100%;
  background-color: white;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

/* Custom Chart Tooltip */
.rgm-chart-custom-tooltip {
  background-color: rgba(255, 255, 255, 0.96);
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.rgm-chart-tooltip-label {
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #333;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.rgm-chart-custom-tooltip p {
  margin: 4px 0;
  font-size: 12px;
  font-weight: 500;
}

/* Table styles */
.rgm-chat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.rgm-chat-table thead {
  background-color: #f8f9fa;
}

.rgm-chat-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #dee2e6;
}

.rgm-chat-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
  color: #495057;
}

/* Numeric column alignment - applies to both th and td */
.rgm-chat-table-numeric {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
}

.rgm-chat-table tbody tr:last-child td {
  border-bottom: none;
}

.rgm-chat-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Suggestions section */
.rgm-chat-suggestions {
  margin-top: 12px;
  display: block;
  max-width: 25vw;
  min-width: 400px;
}

.rgm-chat-suggestions-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.rgm-chat-suggestions-buttons {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rgm-chat-suggestion-btn {
  background: white;
  border: 1px solid #0078a0;
  color: #0078a0;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  text-align: left;
  transition: all 0.2s;
  width: 100%;
}

.rgm-chat-suggestion-btn:hover {
  background: #0078a0;
  color: white;
  transform: translateX(2px);
}

.rgm-chat-suggestion-btn:active {
  transform: translateX(2px) scale(0.98);
}

/* Loading animation */
.rgm-chat-loading-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rgm-chat-loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #0078a0;
  border-radius: 50%;
  animation: rgm-spin 0.8s linear infinite;
}

@keyframes rgm-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rgm-chat-loading-text {
  color: #666;
  font-style: italic;
}

.rgm-chat-suggestion-btn.streaming {
  opacity: 0.7;
  cursor: not-allowed;
}

.rgm-chat-suggestions-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

/* AG Grid Custom Styling for Chat Tables */
.rgm-chat-table-container .ag-theme-alpine {
  --ag-header-background-color: #0078a0;
  --ag-header-foreground-color: #ffffff;
  --ag-border-color: #e5e7eb;
  --ag-row-hover-color: #eef2ff;
  --ag-selected-row-background-color: #e0e7ff;
  --ag-font-size: 13px;
  --ag-font-family: inherit;
  margin-top: 10px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Header background and text */
.rgm-chat-table-container .ag-theme-alpine .ag-header {
  background-color: #0078a0;
  border-bottom: 2px solid #00678a;
}

.rgm-chat-table-container .ag-theme-alpine .ag-header-cell {
  background-color: #0078a0;
  color: #ffffff;
  font-weight: 600;
}

.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-label {
  color: #ffffff;
}

/* Icons in the header row (not in popups) - white */
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-header-icon,
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-filter,
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-menu,
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-asc,
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-desc,
.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-none {
  color: #ffffff !important;
}

/* Menu button in header - white */
.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-menu-button {
  color: #ffffff !important;
}

.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-menu-button .ag-icon {
  color: #ffffff !important;
}

/* Column resize handle */
.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-resize {
  opacity: 0.25;
}

/* Right-aligned numeric cells */
.rgm-chat-table-container .ag-theme-alpine .ag-right-aligned-cell {
  text-align: right;
}

/* Border radius for first/last header cells */
.rgm-chat-table-container .ag-theme-alpine .ag-header-cell:first-child {
  border-top-left-radius: 8px;
}

.rgm-chat-table-container .ag-theme-alpine .ag-header-cell:last-child {
  border-top-right-radius: 8px;
}
/* Chart Type Selector */
.rgm-chart-type-selector {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  flex: 0 0 auto;
}

.rgm-chart-type-buttons {
  display: flex;
  background-color: #e9ecef;
  border-radius: 6px;
  padding: 4px;
  gap: 2px;
}

.rgm-chart-type-btn {
  background: transparent;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  transition: all 0.2s ease;
  flex: 1;
  text-align: center;
}

.rgm-chart-type-btn:hover {
  color: #0078a0;
  background-color: rgba(255, 255, 255, 0.5);
}

.rgm-chart-type-btn.active {
  background-color: white;
  color: #0078a0;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Loading indicator for lazy loading history */
.rgm-chat-load-more-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: #666;
  font-size: 0.85em;
}

.rgm-chat-load-more-indicator .spinner-border {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.rgm-chat-scroll-hint {
  text-align: center;
  padding: 8px;
  color: #999;
  font-size: 0.8em;
  font-style: italic;
}

/* Thinking details box */
.rgm-chat-thinking-box {
  margin: 12px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f8f9fa;
  overflow: hidden;
  max-width: 90%;
  width: 90%;
}

.rgm-chat-thinking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.rgm-chat-thinking-header:hover {
  background-color: #e9ecef;
}

.rgm-chat-thinking-label {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rgm-chat-thinking-toggle {
  background: transparent;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #0078a0;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rgm-chat-thinking-toggle:hover {
  background-color: #e7f5ff;
  border-color: #0078a0;
}

.rgm-chat-thinking-content {
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.rgm-chat-thinking-text {
  font-size: 13px;
  color: #495057;
  line-height: 1.6;
  white-space: pre-wrap;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
}

/* Vega charts container */
.rgm-chat-charts-container {
  margin: 16px 0;
}

/* SQL plain-language explain box (below each data table) */
.rgm-chat-sql-explain-box {
  margin: 8px 0 12px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f8f9fa;
  overflow: hidden;
  max-width: 90%;
  width: 90%;
}

.rgm-chat-sql-explain-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.rgm-chat-sql-explain-header:hover {
  background-color: #e9ecef;
}

.rgm-chat-sql-explain-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rgm-chat-sql-explain-toggle {
  background: transparent;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 3px 10px;
  cursor: pointer;
  font-size: 12px;
  color: #0078a0;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rgm-chat-sql-explain-toggle:hover {
  background-color: #e7f5ff;
  border-color: #0078a0;
}

.rgm-chat-sql-explain-content {
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.rgm-chat-sql-explain-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6c757d;
}

.rgm-chat-sql-explain-text {
  font-size: 13px;
  color: #343a40;
  line-height: 1.65;
}

.rgm-chat-sql-explain-error {
  font-size: 13px;
  color: #c0392b;
}

.rgm-chat-sql-explain-ref {
  margin-top: 8px;
  font-size: 10px;
  color: #adb5bd;
  font-family: monospace;
  user-select: none;
}

.rgm-chat-sql-explain-ref-id {
  user-select: all;
}

.rgm-chat-sql-explain-retry {
  background: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  font-size: 13px;
  color: #0078a0;
  cursor: pointer;
  text-decoration: underline;
}

.rgm-chat-sql-explain-retry:hover {
  color: #005f80;
}

.rgm-chat-history-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 0;
  color: #666;
  font-size: 14px;
}

.rgm-chat-chart-item {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #ffffff;
}

.rgm-chat-chart-item:last-child {
  margin-bottom: 0;
}

.rgm-chat-chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  text-align: center;
}

.rgm-chat-vega-chart {
  width: 100%;
  min-height: 400px;
}

/* ── Related Reports Recommendations ───────────────────────────── */
.rgm-chat-recommendations {
  border-top: 1px solid #e0e0e0;
  background: #f3f7fd;
  padding: 8px 12px 10px;
  flex-shrink: 0;
}

.rgm-chat-recommendations.rgm-chat-recommendations-collapsed {
  padding-bottom: 8px;
}

.rgm-chat-rec-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  cursor: default;
}

.rgm-chat-recommendations.rgm-chat-recommendations-collapsed .rgm-chat-rec-header {
  margin-bottom: 0;
}

.rgm-chat-rec-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #4b7bbf;
  cursor: default;
}

.rgm-chat-rec-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  color: #888;
  width: 12px;
  padding: 0;
  margin-left: 8px;
}
.rgm-chat-rec-toggle:hover {
  color: #333;
}

.rgm-chat-rec-cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 200px;
  overflow-y: auto;
}

.rgm-chat-rec-empty {
  font-size: 12px;
  color: #888;
  padding: 4px 0 2px 15px;
  font-style: italic;
}

.rgm-chat-rec-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fff;
  border: 1px solid #dce8f8;
  border-radius: 6px;
  padding: 8px 10px;
}

.rgm-chat-rec-card-clickable {
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
}
.rgm-chat-rec-card-clickable:hover {
  background: #f0f6ff;
  border-color: #a8c8f0;
}

.rgm-chat-rec-info {
  flex: 1;
  min-width: 0;
}

.rgm-chat-rec-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2933;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rgm-chat-rec-page {
  font-size: 11px;
  color: #4a7ab5;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rgm-chat-rec-open {
  font-size: 14px;
  color: #a0b4cc;
  flex-shrink: 0;
  align-self: center;
  margin-left: auto;
  padding-left: 4px;
}

.rgm-chat-rec-desc {
  font-size: 11px;
  color: #5a6a7a;
  margin-top: 2px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/snowflakeCortexChat/style.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0BAA0B;EAC1B,6BAA6B;EAC7B,2CAA2C;EAC3C,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oDAAoD;AACpD;;;;;;EAME,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;AACA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,qEAAqE;AACrE;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf;;sBAEoB;AACtB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Backdrop overlay */\n.rgm-chat-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n/* Main container for the chat component */\n.rgm-chat-container {\n  background-color: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  /* transition: all 0.3s ease; */\n}\n\n/* Collapsed state - normal positioning */\n.rgm-chat-container.rgm-chat-collapsed {\n  margin: 0 10px 10px 10px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Expanded state - full viewport modal */\n.rgm-chat-container.rgm-chat-expanded {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 97vw;\n  /* max-width: 1200px; */\n  height: 97vh;\n  margin: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n/* Header section with title and chevron */\n.rgm-chat-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  border-bottom: 1px solid #e0e0e0;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.rgm-chat-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  /* margin-right: 8px; */\n}\n\n/* Mode Dropdown */\n.rgm-chat-mode-dropdown-container {\n  position: relative;\n  /* margin-left: 4px; */\n}\n\n.rgm-chat-mode-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  transition: background-color 0.2s;\n  width: fit-content;\n  max-width: 300px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.rgm-chat-mode-dropdown-trigger:hover {\n  background-color: #f0f0f0;\n}\n\n.rgm-chat-mode-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  min-width: 120px;\n  max-width: 300px;\n  padding: 4px 0;\n  overflow: hidden;\n}\n\n.rgm-chat-mode-dropdown-item {\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rgm-chat-mode-dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n.rgm-chat-mode-dropdown-item.active {\n  background-color: #e6f7ff;\n  color: #0078d4;\n  font-weight: 500;\n}\n\n.rgm-chat-model-select-container {\n  position: relative;\n  margin-right: 20px;\n}\n\n.rgm-chat-model-select-trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.rgm-chat-model-select-trigger:hover {\n  background-color: #f0f0f0;\n}\n\n.rgm-chat-model-select-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  min-width: 120px;\n  padding: 4px 0;\n}\n\n.rgm-chat-model-select-item {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.rgm-chat-model-select-item:hover {\n  background-color: #f5f5f5;\n}\n\n.rgm-chat-model-select-item.active {\n  background-color: #e6f7ff;\n  color: #0078d4;\n  font-weight: 500;\n}\n\n.rgm-chat-chevron {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n/* Chat body - contains messages and form */\n.rgm-chat-body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Thread sidebar */\n.rgm-thread-bar {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 170px;\n  flex-shrink: 0;\n  border-right: 1px solid #e0e0e0;\n  background: #f5f6f8;\n}\n\n.rgm-thread-bar-resize-handle {\n  position: absolute;\n  top: 0;\n  right: -6px;\n  width: 12px;\n  height: 100%;\n  cursor: col-resize;\n  z-index: 2;\n}\n\n.rgm-thread-bar-resize-handle:hover {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.rgm-thread-bar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border-bottom: 1px solid #dde0e4;\n  flex-shrink: 0;\n}\n\n.rgm-thread-bar-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.rgm-thread-new-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  color: #555;\n  padding: 0 2px;\n  border-radius: 4px;\n}\n\n.rgm-thread-new-btn:hover {\n  background: #e0e3e8;\n  color: #222;\n}\n\n.rgm-thread-list {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 4px 0;\n  min-width: 0;\n}\n\n.rgm-thread-item {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding: 0 4px;\n  border-radius: 6px;\n  margin: 2px 4px;\n  box-sizing: border-box;\n  transition: background 0.1s;\n}\n\n.rgm-thread-item:hover {\n  background: #e4e7ec;\n}\n\n.rgm-thread-item-active {\n  background: #dce6f5;\n}\n\n.rgm-thread-item-active:hover {\n  background: #cddaf0;\n}\n\n.rgm-thread-item-btn {\n  flex: 1 1 auto;\n  display: block;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n  color: #333;\n  padding: 6px 4px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n/* ⋯ menu button */\n.rgm-thread-menu-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n  color: #aaa;\n  padding: 2px 5px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  display: none;\n}\n.rgm-thread-item:hover .rgm-thread-menu-btn,\n.rgm-thread-item-active .rgm-thread-menu-btn {\n  display: block;\n}\n.rgm-thread-menu-btn:hover {\n  color: #333;\n  background: #d0d4da;\n}\n\n/* Inline rename input */\n.rgm-thread-rename-input {\n  flex: 1;\n  font-size: 12px;\n  border: 1px solid #4f46e5;\n  border-radius: 4px;\n  padding: 3px 6px;\n  outline: none;\n  min-width: 0;\n  background: #fff;\n}\n\n/* Context menu */\n.rgm-thread-context-menu {\n  position: fixed;\n  z-index: 9999;\n  background: #fff;\n  border: 1px solid #dde0e4;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 120px;\n  padding: 4px 0;\n}\n.rgm-thread-context-item {\n  display: block;\n  width: 100%;\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 7px 14px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #333;\n}\n.rgm-thread-context-item:hover {\n  background: #f0f2f5;\n}\n.rgm-thread-context-item--danger {\n  color: #c0392b;\n}\n.rgm-thread-context-item--danger:hover {\n  background: #fde8e6;\n}\n\n/* Delete confirmation overlay */\n.rgm-thread-delete-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rgm-thread-delete-modal {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px 24px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  min-width: 220px;\n  text-align: center;\n}\n.rgm-thread-delete-modal p {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: #333;\n}\n.rgm-thread-delete-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n.rgm-thread-delete-cancel,\n.rgm-thread-delete-confirm {\n  padding: 6px 16px;\n  border-radius: 5px;\n  border: none;\n  font-size: 13px;\n  cursor: pointer;\n}\n.rgm-thread-delete-cancel {\n  background: #e8eaed;\n  color: #333;\n}\n.rgm-thread-delete-cancel:hover {\n  background: #d8dade;\n}\n.rgm-thread-delete-confirm {\n  background: #c0392b;\n  color: #fff;\n}\n.rgm-thread-delete-confirm:hover {\n  background: #a93226;\n}\n\n.rgm-thread-empty {\n  font-size: 11px;\n  color: #aaa;\n  text-align: center;\n  padding: 16px 8px;\n}\n\n/* Main chat area (messages + form) */\n.rgm-chat-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Wrapper for the message list */\n.rgm-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n  background-color: #ffffff;\n  min-height: 0;\n}\n\n/* Individual message container */\n.rgm-chat-message {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n/* Wrapper for bubble and feedback - ensures vertical stacking */\n.rgm-chat-message-content {\n  display: flex;\n  flex-direction: column;\n  width: min(75vw, 100%);\n  max-width: 75vw;\n  align-items: flex-start;\n}\n\n.rgm-chat-bubble {\n  padding: 10px 14px;\n  border-radius: 18px;\n  line-height: 1.4;\n  display: inline-block;\n  width: auto;\n  max-width: 75vw;\n  box-sizing: border-box;\n  align-self: flex-start;\n}\n\n.rgm-chat-bubble.rgm-chat-disclaimer {\n  font-size: 12px;\n  color: #6b7280;\n  background-color: #f8fafc;\n  border: 1px solid #e5e7eb;\n}\n\n/* Override for tables/charts - needs full width */\n.rgm-chat-bubble:has(.rgm-chat-table-container),\n.rgm-chat-bubble:has(.ag-theme-alpine) {\n  display: block;\n  width: 75vw;\n  max-width: 75vw;\n}\n\n/* RGM (analyst) messages */\n.rgm-chat-message.RGM {\n  justify-content: flex-start;\n}\n.rgm-chat-message.RGM .rgm-chat-bubble {\n  background-color: #f1f0f0;\n  color: #333;\n}\n\n/* User messages */\n.rgm-chat-message.user {\n  justify-content: flex-end;\n}\n.rgm-chat-message.user .rgm-chat-message-content {\n  align-items: flex-end;\n}\n.rgm-chat-message.user .rgm-chat-bubble {\n  background-color: #0078a0;\n  color: white;\n  align-self: flex-end;\n}\n\n.rgm-chat-input-disclaimer {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: left;\n  padding: 4px 2px 4px;\n  background-color: #f9f9f9;\n}\n\n.rgm-chat-input-row {\n  display: flex;\n  align-items: flex-end;\n}\n\n.rgm-chat-form {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f9f9f9;\n  flex-shrink: 0;\n}\n\n/* Collapsed form styling */\n.rgm-chat-form-collapsed {\n  border-top: none;\n}\n\n.rgm-chat-input {\n  flex-grow: 1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 8px 15px;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-right: 10px;\n  resize: none;\n  overflow-y: hidden;\n  box-sizing: border-box;\n  height: 36px;\n  font-family: inherit;\n}\n.rgm-chat-input:focus {\n  outline: none;\n  border-color: #0078a0;\n  box-shadow: 0 0 0 2px rgba(0, 120, 160, 0.2);\n}\n\n.rgm-chat-send-btn {\n  border: none;\n  background-color: #0078a0;\n  color: white;\n  font-weight: 600;\n  border-radius: 20px;\n  padding: 8px 20px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n.rgm-chat-send-btn:hover {\n  background-color: #005f7e;\n}\n.rgm-chat-stop-btn {\n  background-color: #b03a2e;\n}\n.rgm-chat-stop-btn:hover {\n  background-color: #8c2d24;\n}\n\n/* Feedback section - appears below the bubble */\n.rgm-chat-feedback {\n  margin-top: 8px;\n  display: block;\n  width: 100%;\n}\n\n.rgm-chat-feedback-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rgm-chat-feedback-btn {\n  background: transparent;\n  border: none;\n  border-radius: 999px;\n  padding: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  min-height: 26px;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.rgm-chat-feedback-btn:hover:not(:disabled) {\n  background: rgba(79, 70, 229, 0.1);\n}\n\n.rgm-chat-feedback-btn.active {\n  background: rgba(79, 70, 229, 0.2);\n}\n\n.rgm-chat-feedback-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.rgm-chat-feedback-thanks {\n  font-size: 12px;\n  color: #4f46e5;\n  font-style: italic;\n}\n\n.rgm-chat-feedback-text-container {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.rgm-chat-feedback-textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.rgm-chat-feedback-textarea:focus {\n  outline: none;\n  border-color: #4f46e5;\n}\n\n.rgm-chat-feedback-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.rgm-chat-feedback-submit {\n  background: #4f46e5;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.rgm-chat-feedback-submit:hover {\n  background: #3730a3;\n}\n\n.rgm-chat-feedback-cancel {\n  background: transparent;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.rgm-chat-feedback-cancel:hover {\n  background: #f5f5f5;\n  border-color: #999;\n}\n\n/* Table and Chart Container */\n.rgm-chat-table-container {\n  width: 100%;\n  margin: 10px 0;\n}\n\n.rgm-chat-table-grid {\n  width: 100%;\n  overflow: auto;\n}\n\n.rgm-chat-table-controls {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.rgm-chat-view-toggle-btn {\n  background: #0078a0;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.rgm-chat-view-toggle-btn:hover {\n  background: #005f7e;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 120, 160, 0.3);\n}\n\n.rgm-chat-view-toggle-btn:active {\n  transform: translateY(0);\n}\n\n.rgm-chat-copy-chart-btn {\n  background: #e8f4f8;\n  color: #0078a0;\n  border: 1px solid #0078a0;\n  border-radius: 6px;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.rgm-chat-copy-chart-btn:hover {\n  background: #d0eaf3;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 120, 160, 0.2);\n}\n\n.rgm-chat-copy-chart-btn:active {\n  transform: translateY(0);\n}\n\n.rgm-chat-copy-chart-btn.copied {\n  background: #e6f4ea;\n  color: #1a7f37;\n  border-color: #1a7f37;\n}\n\n.rgm-chat-copy-chart-btn.error {\n  background: #fce8e6;\n  color: #c5221f;\n  border-color: #c5221f;\n}\n\n/* Metric Selector */\n.rgm-chart-metric-selector {\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.rgm-chart-metric-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.rgm-chart-metric-checkboxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.rgm-chart-metric-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #495057;\n  transition: color 0.2s;\n}\n\n.rgm-chart-metric-checkbox-label:hover {\n  color: #0078a0;\n}\n\n.rgm-chart-metric-checkbox {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  accent-color: #0078a0;\n}\n\n.rgm-chart-metric-name {\n  user-select: none;\n}\n\n/* Chart wrapper */\n.rgm-chat-chart-wrapper {\n  width: 100%;\n  max-width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  padding: 15px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n/* Custom Chart Tooltip */\n.rgm-chart-custom-tooltip {\n  background-color: rgba(255, 255, 255, 0.96);\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 10px 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.rgm-chart-tooltip-label {\n  font-weight: 600;\n  margin: 0 0 6px 0;\n  color: #333;\n  font-size: 13px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 4px;\n}\n\n.rgm-chart-custom-tooltip p {\n  margin: 4px 0;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Table styles */\n.rgm-chat-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  background-color: white;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.rgm-chat-table thead {\n  background-color: #f8f9fa;\n}\n\n.rgm-chat-table th {\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.rgm-chat-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #dee2e6;\n  color: #495057;\n}\n\n/* Numeric column alignment - applies to both th and td */\n.rgm-chat-table-numeric {\n  text-align: right !important;\n  font-variant-numeric: tabular-nums;\n}\n\n.rgm-chat-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.rgm-chat-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n/* Suggestions section */\n.rgm-chat-suggestions {\n  margin-top: 12px;\n  display: block;\n  max-width: 25vw;\n  min-width: 400px;\n}\n\n.rgm-chat-suggestions-label {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.rgm-chat-suggestions-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rgm-chat-suggestion-btn {\n  background: white;\n  border: 1px solid #0078a0;\n  color: #0078a0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  text-align: left;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.rgm-chat-suggestion-btn:hover {\n  background: #0078a0;\n  color: white;\n  transform: translateX(2px);\n}\n\n.rgm-chat-suggestion-btn:active {\n  transform: translateX(2px) scale(0.98);\n}\n\n/* Loading animation */\n.rgm-chat-loading-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rgm-chat-loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e0e0e0;\n  border-top: 2px solid #0078a0;\n  border-radius: 50%;\n  animation: rgm-spin 0.8s linear infinite;\n}\n\n@keyframes rgm-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.rgm-chat-loading-text {\n  color: #666;\n  font-style: italic;\n}\n\n.rgm-chat-suggestion-btn.streaming {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.rgm-chat-suggestions-label {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n/* AG Grid Custom Styling for Chat Tables */\n.rgm-chat-table-container .ag-theme-alpine {\n  --ag-header-background-color: #0078a0;\n  --ag-header-foreground-color: #ffffff;\n  --ag-border-color: #e5e7eb;\n  --ag-row-hover-color: #eef2ff;\n  --ag-selected-row-background-color: #e0e7ff;\n  --ag-font-size: 13px;\n  --ag-font-family: inherit;\n  margin-top: 10px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Header background and text */\n.rgm-chat-table-container .ag-theme-alpine .ag-header {\n  background-color: #0078a0;\n  border-bottom: 2px solid #00678a;\n}\n\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell {\n  background-color: #0078a0;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-label {\n  color: #ffffff;\n}\n\n/* Icons in the header row (not in popups) - white */\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-header-icon,\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-filter,\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-menu,\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-asc,\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-desc,\n.rgm-chat-table-container .ag-theme-alpine .ag-header-row .ag-icon-none {\n  color: #ffffff !important;\n}\n\n/* Menu button in header - white */\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-menu-button {\n  color: #ffffff !important;\n}\n\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-menu-button .ag-icon {\n  color: #ffffff !important;\n}\n\n/* Column resize handle */\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell-resize {\n  opacity: 0.25;\n}\n\n/* Right-aligned numeric cells */\n.rgm-chat-table-container .ag-theme-alpine .ag-right-aligned-cell {\n  text-align: right;\n}\n\n/* Border radius for first/last header cells */\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell:first-child {\n  border-top-left-radius: 8px;\n}\n\n.rgm-chat-table-container .ag-theme-alpine .ag-header-cell:last-child {\n  border-top-right-radius: 8px;\n}\n/* Chart Type Selector */\n.rgm-chart-type-selector {\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px;\n  flex: 0 0 auto;\n}\n\n.rgm-chart-type-buttons {\n  display: flex;\n  background-color: #e9ecef;\n  border-radius: 6px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.rgm-chart-type-btn {\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  transition: all 0.2s ease;\n  flex: 1;\n  text-align: center;\n}\n\n.rgm-chart-type-btn:hover {\n  color: #0078a0;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.rgm-chart-type-btn.active {\n  background-color: white;\n  color: #0078a0;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Loading indicator for lazy loading history */\n.rgm-chat-load-more-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  color: #666;\n  font-size: 0.85em;\n}\n\n.rgm-chat-load-more-indicator .spinner-border {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n}\n\n.rgm-chat-scroll-hint {\n  text-align: center;\n  padding: 8px;\n  color: #999;\n  font-size: 0.8em;\n  font-style: italic;\n}\n\n/* Thinking details box */\n.rgm-chat-thinking-box {\n  margin: 12px 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n  overflow: hidden;\n  max-width: 90%;\n  width: 90%;\n}\n\n.rgm-chat-thinking-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.rgm-chat-thinking-header:hover {\n  background-color: #e9ecef;\n}\n\n.rgm-chat-thinking-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rgm-chat-thinking-toggle {\n  background: transparent;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 4px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #0078a0;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.rgm-chat-thinking-toggle:hover {\n  background-color: #e7f5ff;\n  border-color: #0078a0;\n}\n\n.rgm-chat-thinking-content {\n  padding: 12px 16px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #ffffff;\n}\n\n.rgm-chat-thinking-text {\n  font-size: 13px;\n  color: #495057;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  font-family: \"Consolas\", \"Monaco\", \"Courier New\", monospace;\n}\n\n/* Vega charts container */\n.rgm-chat-charts-container {\n  margin: 16px 0;\n}\n\n/* SQL plain-language explain box (below each data table) */\n.rgm-chat-sql-explain-box {\n  margin: 8px 0 12px 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n  overflow: hidden;\n  max-width: 90%;\n  width: 90%;\n}\n\n.rgm-chat-sql-explain-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.rgm-chat-sql-explain-header:hover {\n  background-color: #e9ecef;\n}\n\n.rgm-chat-sql-explain-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rgm-chat-sql-explain-toggle {\n  background: transparent;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 3px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #0078a0;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.rgm-chat-sql-explain-toggle:hover {\n  background-color: #e7f5ff;\n  border-color: #0078a0;\n}\n\n.rgm-chat-sql-explain-content {\n  padding: 12px 16px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #ffffff;\n}\n\n.rgm-chat-sql-explain-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #6c757d;\n}\n\n.rgm-chat-sql-explain-text {\n  font-size: 13px;\n  color: #343a40;\n  line-height: 1.65;\n}\n\n.rgm-chat-sql-explain-error {\n  font-size: 13px;\n  color: #c0392b;\n}\n\n.rgm-chat-sql-explain-ref {\n  margin-top: 8px;\n  font-size: 10px;\n  color: #adb5bd;\n  font-family: monospace;\n  user-select: none;\n}\n\n.rgm-chat-sql-explain-ref-id {\n  user-select: all;\n}\n\n.rgm-chat-sql-explain-retry {\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: 4px;\n  font-size: 13px;\n  color: #0078a0;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.rgm-chat-sql-explain-retry:hover {\n  color: #005f80;\n}\n\n.rgm-chat-history-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.rgm-chat-chart-item {\n  margin-bottom: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: #ffffff;\n}\n\n.rgm-chat-chart-item:last-child {\n  margin-bottom: 0;\n}\n\n.rgm-chat-chart-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n.rgm-chat-vega-chart {\n  width: 100%;\n  min-height: 400px;\n}\n\n/* ── Related Reports Recommendations ───────────────────────────── */\n.rgm-chat-recommendations {\n  border-top: 1px solid #e0e0e0;\n  background: #f3f7fd;\n  padding: 8px 12px 10px;\n  flex-shrink: 0;\n}\n\n.rgm-chat-recommendations.rgm-chat-recommendations-collapsed {\n  padding-bottom: 8px;\n}\n\n.rgm-chat-rec-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  cursor: default;\n}\n\n.rgm-chat-recommendations.rgm-chat-recommendations-collapsed .rgm-chat-rec-header {\n  margin-bottom: 0;\n}\n\n.rgm-chat-rec-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: #4b7bbf;\n  cursor: default;\n}\n\n.rgm-chat-rec-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 10px;\n  line-height: 1;\n  color: #888;\n  width: 12px;\n  padding: 0;\n  margin-left: 8px;\n}\n.rgm-chat-rec-toggle:hover {\n  color: #333;\n}\n\n.rgm-chat-rec-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.rgm-chat-rec-empty {\n  font-size: 12px;\n  color: #888;\n  padding: 4px 0 2px 15px;\n  font-style: italic;\n}\n\n.rgm-chat-rec-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #fff;\n  border: 1px solid #dce8f8;\n  border-radius: 6px;\n  padding: 8px 10px;\n}\n\n.rgm-chat-rec-card-clickable {\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n}\n.rgm-chat-rec-card-clickable:hover {\n  background: #f0f6ff;\n  border-color: #a8c8f0;\n}\n\n.rgm-chat-rec-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.rgm-chat-rec-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2933;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rgm-chat-rec-page {\n  font-size: 11px;\n  color: #4a7ab5;\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rgm-chat-rec-open {\n  font-size: 14px;\n  color: #a0b4cc;\n  flex-shrink: 0;\n  align-self: center;\n  margin-left: auto;\n  padding-left: 4px;\n}\n\n.rgm-chat-rec-desc {\n  font-size: 11px;\n  color: #5a6a7a;\n  margin-top: 2px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
